module.exports = __webpack_public_path__ + "static/media/hahnemuhle-bright-white.f282e6db.jpg";